// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/theme/ink-blue.scss
// module id = 1185
// module chunks = 50